import { useEffect, useState } from 'react'
import { DateRange } from 'react-day-picker'

import { Button } from '@/components/ui/button'
import { ComparisonSelection } from '@/components/ui/charts/types'
import { ChartType } from '@/components/ui/charts/types/chart-props'
import { Interval } from '@/types/clarity/metrics/sales'
import { TIME_FILTER_OPTIONS } from '@/utils'

interface TimeFilterButtonsProps {
  dateRange: DateRange | undefined
  intervalValue: Interval
  setIntervalValue: (interval: Interval) => void
  fixedInterval?: Interval | null
  comparison?: ComparisonSelection | null
  chartType: ChartType
}

const TimeFilterButtons: React.FC<TimeFilterButtonsProps> = ({
  dateRange,
  intervalValue,
  setIntervalValue,
  fixedInterval,
  comparison,
  chartType,
}) => {
  const [dateDiff, setDateDiff] = useState<number>(0)
  const [basicDatePickerButton, setBasicDatePickerButton] = useState(['month'])

  useEffect(() => {
    if (dateRange?.from) {
      const toDate = dateRange.to || dateRange.from // Default to `from` if `to` is undefined
      const dateDiff = Math.ceil(
        (toDate.getTime() - dateRange.from.getTime()) / (1000 * 60 * 60 * 24)
      )
      setDateDiff(dateDiff)

      if (chartType === 'spend' || chartType === 'pnl') {
        if (dateDiff > 180) {
          setBasicDatePickerButton(['month', 'quarter'])
        } else {
          setBasicDatePickerButton(['month'])
        }
      }
    }
  }, [dateRange])

  return (
    <div className="flex space-x-2">
      {TIME_FILTER_OPTIONS.map((option) => {
        let isSelected = option.value === intervalValue
        if (fixedInterval) {
          isSelected = fixedInterval === option.value
        }
        let isDisabled = false
        if (comparison?.type === 'period') {
          isDisabled = !['hour', 'month', 'quarter', 'dow'].includes(
            option.value
          )
        }
        if (chartType === 'spend' || chartType === 'pnl') {
          isDisabled = !basicDatePickerButton.includes(option.value)
        } else {
          isDisabled = fixedInterval
            ? !fixedInterval.includes(option.value)
            : !option.condition(dateDiff)
        }
        return (
          <Button
            key={option.value}
            variant={isSelected ? 'default' : 'outline'}
            onClick={() => setIntervalValue(option.value)}
            className="h-10 w-10 p-0 text-md"
            title={option.label}
            disabled={isDisabled}
          >
            {option.label.charAt(0)}
          </Button>
        )
      })}
    </div>
  )
}

export { TimeFilterButtons }
